import { RouteType } from "../../../types/RouteType";

const qcApprovalRoute: RouteType = {
  name: "QC Approval",
  path: "/qc/approval/:inspectionId?",
  defaultParams: {
    inspectionId: null,
  },
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./QCApproval.Header"),
      title: "Approve Inspection",
      color: "primary",
      enableBackButton: true,
    },
    body: {
      component: () => import("./QCApproval.Body"),
      grayBackground: false,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false, // TODO: Add 'qc:manager' permission check

  beforeEnter: async ({ rootStore, params }) => {
    try {
      const store = rootStore.qcApprovalStore;
      const inspectionsStore = rootStore["qc-inspectionsStore"];

      // Load pending approvals
      if (
        inspectionsStore &&
        typeof inspectionsStore === "object" &&
        "find" in inspectionsStore
      ) {
        await (inspectionsStore as any).find({
          query: { status: "pending_approval" },
        });
      }

      // If inspectionId provided (UUID string), pre-select it
      if (
        params.inspectionId &&
        store &&
        typeof store === "object" &&
        "selectInspection" in store
      ) {
        await (store as any).selectInspection(params.inspectionId as string);
      }

      return true;
    } catch (error) {
      console.error("Failed to load QC Approval:", error);
      return false;
    }
  },

  onParamsChange: async ({ rootStore, params, previousParams }) => {
    if (params.inspectionId !== previousParams?.inspectionId) {
      const store = rootStore.qcApprovalStore;
      if (
        params.inspectionId &&
        store &&
        typeof store === "object" &&
        "selectInspection" in store
      ) {
        await (store as any).selectInspection(params.inspectionId as string);
      }
    }
  },

  onExit: ({ rootStore }) => {
    const store = rootStore.qcApprovalStore;
    if (store && typeof store === "object" && "reset" in store) {
      (store as any).reset();
    }
  },

  dialogs: [],
};

export default qcApprovalRoute;
